module.exports = __webpack_public_path__ + "img/car_3.0d8c069e.jpg";